/**
 * Team Invitation Email Template
 * Generates HTML email for team invitations
 */

import type { TeamInvitationData } from '@/shared/types';

export function generateTeamInvitationEmail(teamData: TeamInvitationData): string {
  return `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="utf-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>Team Invitation</title>
      <style>
        body { font-family: Arial, sans-serif; line-height: 1.6; color: #333; }
        .container { max-width: 600px; margin: 0 auto; padding: 20px; }
        .header { background: #4f46e5; color: white; padding: 20px; border-radius: 8px 8px 8px 8px; text-align: center; }
        .content { background: #f9fafb; padding: 20px; border-radius: 8px; }
        .button { display: inline-block; background: #4f46e5; color: white; padding: 12px 24px; text-decoration: none; border-radius: 6px; margin-top: 20px; }
      </style>
    </head>
    <body>
      <div class="container">
        <div class="header">
          <h1>You're Invited!</h1>
        </div>
        <div class="content">
          <p>You've been invited to join <strong>${teamData.teamName}</strong> on SwaySuite!</p>
          <p>Join the team to collaborate on projects and manage your business together.</p>
          <a href="${teamData.inviteLink}" class="button">Accept Invitation</a>
        </div>
      </div>
    </body>
    </html>
  `;
}
